export const SIGN_IN_VIEW = "signIn";
export const SIGN_UP_VIEW = "signUp";
export const SELECT_PREFERENCES_VIEW = "preferences";
export const RESET_PASSWORD_VIEW = "resetPassword";
export const TERMS_OF_SERVICE_VIEW = "termsOfService";
export const PRIVACY_POLICY_VIEW = "privacyPolicy";
